import ppl from "../../../../../assets/subscriptions/img_1.png";

import {SubscriptionRows} from "../../../types/SubscriptionType";
import {useDispatch} from "react-redux";
import {
    setFieldsForEditSubscriptionModal,
    setFieldsForQuickAddModal
} from "../../../../../state/ArbitrarySlice/ArbitratySlice.ts";
import {openModal} from "../../../../../state/ModalSlice/ModalSlice.ts";
import {Tooltip} from "@mui/material";
import {useNavigate} from "react-router-dom";
import { RootState, useAppSelector } from "../../../../../state/state.tsx";
import { toast } from "react-toastify";
import { selectBankAccounts, selectActiveRole } from "../../../../../state/UserStatesV2/userSliceV2.ts";


interface Props extends SubscriptionRows {
    viewType: 'list' | 'grid';
}


export default function SubscriptionRowsRenderer({ viewType, ...props }: Props) {
    const Dispatch = useDispatch();

    const bankAccount =useAppSelector(selectBankAccounts);
    const activeRole = useAppSelector(selectActiveRole);
   
    const onClickfn = (id: string, subcriptionName: string, type: string, advance: number, Price: number , align2monthlyBoundary: boolean) => {
        if(bankAccount.length === 0){
            toast.error("Please add bank account, before adding subscriber")
            Dispatch(openModal("AddBankAccountOpen"))
            return
        }
        Dispatch(openModal("AddLiveSubscriptionModalOpen"))
        Dispatch(setFieldsForQuickAddModal({
            id: id, subscriptionName: subcriptionName, type: type, advance: advance, Price: Price, align2monthlyBoundary: align2monthlyBoundary
        }))
    }

    function setDispatchesForEditSub(id: string, showMeInList: boolean, Name: string, Price: string, paymentProfileId: number) {
        Dispatch(setFieldsForEditSubscriptionModal({
            id: id,
            showMeInList: showMeInList,
            Name: Name,
            Price: Price,
            paymentProfileID: paymentProfileId
        }))

        Dispatch(openModal("EditSubscriptionModalOpen"))
    }

    const subscriberCountDisplay = props.activeSubscribersCount ?? 0;

    const navigate = useNavigate()

    function onClickSub(id: string): void {
        navigate(`/mysubscriptions/subscription/${id}`)
    }

    if (viewType === 'list') {
        return (
            <div onClick={() => onClickSub(props.id)}
                 className={" cursor-pointer mt-2 shadow-md border-[1px] border-gray-300  hover:bg-gray-100  bg-white rounded-xl p-2 h-[6.5rem]  flex"}>
                <div className={"mr-4"}>
                    <img src={props.picture} className={"h-[100%] aspect-square rounded-xl"} alt={"asfsa"}/>
                </div>
                <div className={"w-[87%] flex flex-col justify-between"}>
                    <div className={"flex justify-between items-center w-full"}>
                        <div>
                            <span className={"font-semibold text-lg truncate max-w-[300px] block"} title={props.Name}>
                                {props.Name}
                            </span>
                        </div>
                        <div className={"text"}>
                            {props.subscriptionType === "Monthly" ? `₹${ activeRole?.role === "Observer" ? "XXX" : props.Price}/month` : 
                             props.subscriptionType === "Count" ? (props.isCountHourly ? 
                                <span className="">Count Hourly</span> : 
                                "Count Based Pricing") :
                             `Multi-Month Prices`}
                        </div>
                    </div>
                    <div className={"flex mt-1.5 items-center"}>
                        <svg width="16" height="12" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clipPath="url(#clip0_1_190)">
                                <path
                                    d="M8.15404 3.75C7.66088 3.75 7.17879 3.89662 6.76874 4.17133C6.35869 4.44603 6.0391 4.83648 5.85037 5.29329C5.66165 5.75011 5.61227 6.25277 5.70848 6.73773C5.80469 7.22268 6.04217 7.66814 6.39089 8.01777C6.73961 8.3674 7.1839 8.6055 7.66759 8.70196C8.15128 8.79843 8.65263 8.74892 9.10825 8.5597C9.56388 8.37048 9.9533 8.05005 10.2273 7.63893C10.5013 7.2278 10.6475 6.74445 10.6475 6.25C10.6475 5.58696 10.3848 4.95107 9.91719 4.48223C9.44958 4.01339 8.81535 3.75 8.15404 3.75ZM8.15404 7.5C7.90746 7.5 7.66642 7.42669 7.46139 7.28934C7.25637 7.15199 7.09657 6.95676 7.00221 6.72835C6.90785 6.49995 6.88316 6.24861 6.93126 6.00614C6.97937 5.76366 7.09811 5.54093 7.27247 5.36612C7.44683 5.1913 7.66897 5.07225 7.91082 5.02402C8.15266 4.97579 8.40334 5.00054 8.63115 5.09515C8.85896 5.18976 9.05367 5.34998 9.19067 5.55554C9.32766 5.7611 9.40078 6.00277 9.40078 6.25C9.40078 6.58152 9.26943 6.89946 9.03562 7.13388C8.80181 7.3683 8.4847 7.5 8.15404 7.5Z"
                                    fill="black"/>
                                <path
                                    d="M8.15405 15C7.62913 15.0027 7.11122 14.8793 6.64366 14.64C6.17611 14.4008 5.77253 14.0527 5.4667 13.625C3.09105 10.3394 1.88608 7.86937 1.88608 6.28312C1.88608 4.6164 2.54645 3.01795 3.72192 1.8394C4.89739 0.660851 6.49168 -0.00125122 8.15405 -0.00125122C9.81641 -0.00125122 11.4107 0.660851 12.5862 1.8394C13.7616 3.01795 14.422 4.6164 14.422 6.28312C14.422 7.86937 13.217 10.3394 10.8414 13.625C10.5356 14.0527 10.132 14.4008 9.66443 14.64C9.19687 14.8793 8.67896 15.0027 8.15405 15ZM8.15405 1.36312C6.85271 1.36461 5.6051 1.88358 4.68492 2.80617C3.76474 3.72876 3.24713 4.97963 3.24564 6.28437C3.24564 7.54062 4.42568 9.86375 6.56757 12.8256C6.74941 13.0767 6.98795 13.2811 7.2637 13.422C7.53944 13.563 7.84454 13.6364 8.15405 13.6364C8.46355 13.6364 8.76865 13.563 9.04439 13.422C9.32014 13.2811 9.55868 13.0767 9.74052 12.8256C11.8824 9.86375 13.0624 7.54062 13.0624 6.28437C13.061 4.97963 12.5434 3.72876 11.6232 2.80617C10.703 1.88358 9.45538 1.36461 8.15405 1.36312Z"
                                    fill="black"/>
                            </g>
                            <defs>
                                <clipPath id="clip0_1_190">
                                    <rect width="14.9608" height="18" fill="white" transform="translate(0.67363)"/>
                                </clipPath>
                            </defs>
                        </svg>
                        <span className={"text-sm"}>
                                {props.placeName}
                            </span>

                    </div>
                    <div className={"flex justify-between"}>
                        <div className={"flex items-end"}>
                            <img src={ppl} className={"h-5 w-12 aspect-square rounded-xl"} alt={"asfsa"}/>
                            <p className={"ml-2 text-sm"}>{subscriberCountDisplay <= 1 ? `${subscriberCountDisplay} subscriber` : `${subscriberCountDisplay} subscribers`} </p>
                        </div>
                        <div className={"flex gap-4"}>
                            <div className={"flex justify-center items-end"}>
                                {activeRole?.role !== "Observer" && <button className={"flex justify-center items-center px-2 bg-cc_brand rounded-lg p-1.5"}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            onClickfn(props.id, props.Name, props.type, props.advance, props.Price, props.align2monthlyBoundary)
                                        }}>

                                    <svg width="14" height="14" viewBox="0 0 19 18" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <path d="M9.5 3V15M15.5 9L3.5 9" stroke="#F9FAFB" strokeWidth="2"
                                              strokeLinecap="round"
                                              strokeLinejoin="round"/>
                                    </svg>
                                    <span className="text-white text-xs">Add Student</span>

                                </button>}
                            </div>
                            {activeRole?.role !== "Observer" && <div className={"mr-2 p-2 rounded-full hover:bg-gray-200 flex items-end"} onClick={(e) => {
                                e.stopPropagation();
                                setDispatchesForEditSub(props.id, props.showMeInList, props.Name, props.Price.toString(), props.paymentProfileId)
                            }}>
                                <Tooltip title={"Edit subscription"} arrow>
                                    <div>
                                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
                                             xmlns="http://www.w3.org/2000/svg">
                                            <g clipPath="url(#clip0_1_277)">
                                                <path
                                                    d="M22.853 1.14812C22.1732 0.469319 21.2517 0.0880585 20.291 0.0880585C19.3303 0.0880585 18.4089 0.469319 17.729 1.14812L1.46501 17.4121C0.999266 17.8753 0.629977 18.4261 0.378513 19.0329C0.127049 19.6397 -0.00159798 20.2903 1.49812e-05 20.9471V23.0001C1.49812e-05 23.2653 0.105372 23.5197 0.292908 23.7072C0.480445 23.8948 0.734798 24.0001 1.00001 24.0001H3.05301C3.70978 24.002 4.36038 23.8735 4.96717 23.6222C5.57396 23.3709 6.12487 23.0018 6.58801 22.5361L22.853 6.27112C23.5315 5.59132 23.9126 4.67009 23.9126 3.70962C23.9126 2.74916 23.5315 1.82793 22.853 1.14812ZM5.17401 21.1221C4.61002 21.6824 3.84798 21.9978 3.05301 22.0001H2.00001V20.9471C1.999 20.553 2.07617 20.1626 2.22705 19.7986C2.37793 19.4345 2.59953 19.104 2.87901 18.8261L15.222 6.48312L17.522 8.78312L5.17401 21.1221ZM21.438 4.85712L18.932 7.36412L16.632 5.06912L19.139 2.56212C19.29 2.41143 19.4693 2.29196 19.6664 2.21053C19.8636 2.1291 20.0749 2.08731 20.2883 2.08754C20.5016 2.08778 20.7128 2.13003 20.9098 2.21188C21.1069 2.29374 21.2858 2.4136 21.4365 2.56462C21.5872 2.71564 21.7067 2.89486 21.7881 3.09206C21.8695 3.28925 21.9113 3.50055 21.9111 3.71389C21.9109 3.92723 21.8686 4.13844 21.7868 4.33545C21.7049 4.53247 21.585 4.71143 21.434 4.86212L21.438 4.85712Z"
                                                    fill="#1D4ED8"/>
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_1_277">
                                                    <rect width="24" height="24" fill="white"/>
                                                </clipPath>
                                            </defs>
                                        </svg>
                                    </div>
                                </Tooltip>
                            </div>}
                        </div>

                    </div>
                </div>
            </div>
        )
    }

    return (
        <div 
            onClick={() => onClickSub(props.id)}
            className="bg-white rounded-xl border border-gray-200 p-4 hover:shadow-lg transition-all duration-200 cursor-pointer group"
        >
            {/* Header Section */}
            <div className="flex justify-between items-start mb-3">
                <div className="flex-1 min-w-0">
                    <h3 className="font-semibold text-base truncate text-gray-800 group-hover:text-cc_brand transition-colors duration-200" 
                        title={props.Name}>
                        {props.Name}
                    </h3>
                    <div className="text-gray-500 text-xs mt-0.5 truncate" title={props.placeName}>
                        {props.placeName}
                    </div>
                </div>
                <div className="text-right flex-shrink-0 bg-gray-50 px-2 py-1 rounded-lg ml-2">
                    {props.subscriptionType === "Monthly" ? (
                        <div className="text-gray-700 text-sm">
                            <span className="font-semibold text-cc_brand">₹ { activeRole?.role === "Observer" ? "XXX" : props.Price}</span>
                            <span className="text-xs text-gray-500">/mo</span>
                        </div>
                    ) : props.subscriptionType === "Count" ? (
                        <div className="text-gray-700">
                            <span className={`font-medium text-xs text-cc_brand`}>
                                {props.isCountHourly ? "Count Hourly" : "Count Based"}
                            </span>
                        </div>
                    ) : (
                        <div className="text-gray-700">
                            <span className="font-medium text-cc_brand text-xs">Multi-Month</span>
                        </div>
                    )}
                </div>
            </div>
            
            {/* Divider */}
            <div className="border-t border-gray-100 my-2"></div>
            
            {/* Footer Section */}
            <div className="flex justify-between items-center">
                <div className="flex items-center gap-2 min-w-0">
                    <div className="bg-gray-50 rounded-lg px-2 py-1 flex items-center gap-1.5">
                        <img src={ppl} className="h-4 w-4 rounded-full" alt="subscribers"/>
                        <p className="text-xs text-gray-600 font-medium truncate">
                            {subscriberCountDisplay <= 1 
                                ? `${subscriberCountDisplay} subscriber` 
                                : `${subscriberCountDisplay} subscribers`
                            }
                        </p>
                    </div>
                </div>
                
                <div className="flex items-center gap-2 ml-2">
                    {activeRole?.role !== "Observer" && <button 
                        onClick={(e) => {
                            e.stopPropagation();
                            onClickfn(props.id, props.Name, props.type, props.advance, props.Price, props.align2monthlyBoundary)
                        }}
                        className="flex items-center gap-1 px-2 py-1 bg-cc_brand text-white rounded-lg hover:bg-cc_brand_hover transition-colors duration-200 text-xs font-medium"
                    >
                        <svg width="10" height="10" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9.5 3V15M15.5 9L3.5 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        Add
                    </button>}

                    {activeRole?.role !== "Observer" && <div 
                        className="p-1.5 rounded-lg hover:bg-gray-100 transition-colors duration-200" 
                        onClick={(e) => {
                            e.stopPropagation();
                            setDispatchesForEditSub(props.id, props.showMeInList, props.Name, props.Price.toString(), props.paymentProfileId)
                        }}
                    >
                        <Tooltip title="Edit subscription" arrow>
                            <div>
                                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="text-cc_brand">
                                    <g clipPath="url(#clip0_1_277)">
                                        <path d="M22.853 1.14812C22.1732 0.469319 21.2517 0.0880585 20.291 0.0880585C19.3303 0.0880585 18.4089 0.469319 17.729 1.14812L1.46501 17.4121C0.999266 17.8753 0.629977 18.4261 0.378513 19.0329C0.127049 19.6397 -0.00159798 20.2903 1.49812e-05 20.9471V23.0001C1.49812e-05 23.2653 0.105372 23.5197 0.292908 23.7072C0.480445 23.8948 0.734798 24.0001 1.00001 24.0001H3.05301C3.70978 24.002 4.36038 23.8735 4.96717 23.6222C5.57396 23.3709 6.12487 23.0018 6.58801 22.5361L22.853 6.27112C23.5315 5.59132 23.9126 4.67009 23.9126 3.70962C23.9126 2.74916 23.5315 1.82793 22.853 1.14812Z" fill="currentColor"/>
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_1_277">
                                            <rect width="24" height="24" fill="white"/>
                                        </clipPath>
                                    </defs>
                                </svg>
                            </div>
                        </Tooltip>
                    </div>}
                </div>
            </div>
        </div>
    );
}


